import * as React from 'react'
import { useSearchParams } from 'react-router-dom'

import { formatDate } from '../../../../app/header/utils'
import { DATE_FORMAT_DB, DATE_FORMAT_VIEW } from '../constants/common'
import { ColumnId, OptionsQuery } from '../types'
import { FilterSelect } from './FilterSelect'

export function DateFilter({ currentExpiry, expiries }: { currentExpiry: string; expiries: string[] }) {
  const [, setSearchParams] = useSearchParams()

  const filterOptions = React.useMemo(
    () => expiries.map((option) => ({ label: formatDate(option, DATE_FORMAT_DB, DATE_FORMAT_VIEW), value: option })),
    [expiries]
  )

  return (
    <FilterSelect
      filterColumn={ColumnId.ExpirationDate}
      selected={currentExpiry}
      options={filterOptions}
      onChange={(option) => {
        setSearchParams((prev) => {
          const newQuery = new URLSearchParams(prev)
          newQuery.set(OptionsQuery.Expiry, option.value)
          return newQuery
        })
      }}
    />
  )
}
